"use client";
import {
  useMenuList
} from "../__chunks/Y3DDLZ45.js";
import {
  useMenuProviderContext
} from "../__chunks/QQ7MJHYB.js";
import "../__chunks/KDNXDIJO.js";
import "../__chunks/7PHIY4AC.js";
import "../__chunks/6QXBPV75.js";
import "../__chunks/X3ATWMYX.js";
import "../__chunks/KSMDNUGB.js";
import {
  useHovercard
} from "../__chunks/SJHIAJ6X.js";
import "../__chunks/YMV43K4F.js";
import "../__chunks/QAVVMLZP.js";
import {
  createDialogComponent
} from "../__chunks/4MXLDXAO.js";
import "../__chunks/JQ2AMQCL.js";
import "../__chunks/G5X3WBMZ.js";
import "../__chunks/YPQ27YD7.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/TL67WVI6.js";
import "../__chunks/CU5FOQJK.js";
import "../__chunks/BULCTPRV.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/72E5EPFF.js";
import "../__chunks/OOBDFMJL.js";
import "../__chunks/ZGFCAP4H.js";
import "../__chunks/X6WIMZJE.js";
import "../__chunks/3I4EOZD7.js";
import "../__chunks/QZMQZL6N.js";
import "../__chunks/UYRJLDVS.js";
import "../__chunks/5TQMQMFE.js";
import "../__chunks/LH4OUJXP.js";
import "../__chunks/7452U3HH.js";
import "../__chunks/XPF5GU3Q.js";
import "../__chunks/EAY52LAK.js";
import "../__chunks/QUBURLUM.js";
import "../__chunks/B4BLW6E7.js";
import "../__chunks/7CRP5UGO.js";
import "../__chunks/SNQAYGW2.js";
import "../__chunks/P3UIANB7.js";
import "../__chunks/HJIEYVEO.js";
import "../__chunks/SHA3WOPI.js";
import "../__chunks/B6ZZAB7E.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/LFJDOMBA.js";
import "../__chunks/XWCMZCWT.js";
import "../__chunks/4ORPOXHX.js";
import "../__chunks/2ID5JPOO.js";
import {
  useMergeRefs
} from "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/2SMRF6AD.js";

// src/menu/menu.tsx
import { createRef, useEffect, useRef, useState } from "react";
import { hasFocusWithin } from "@ariakit/core/utils/focus";
import { invariant, isFalsyBooleanCallback } from "@ariakit/core/utils/misc";
var useMenu = createHook(
  (_a) => {
    var _b = _a, {
      store,
      modal: modalProp = false,
      portal = !!modalProp,
      hideOnEscape = true,
      autoFocusOnShow = true,
      hideOnHoverOutside,
      alwaysVisible
    } = _b, props = __objRest(_b, [
      "store",
      "modal",
      "portal",
      "hideOnEscape",
      "autoFocusOnShow",
      "hideOnHoverOutside",
      "alwaysVisible"
    ]);
    const context = useMenuProviderContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const ref = useRef(null);
    const parentMenu = store.parent;
    const parentMenuBar = store.menubar;
    const hasParentMenu = !!parentMenu;
    const parentIsMenuBar = !!parentMenuBar && !hasParentMenu;
    props = __spreadProps(__spreadValues({}, props), {
      ref: useMergeRefs(ref, props.ref)
    });
    const _a2 = useMenuList(
      __spreadValues({ store, alwaysVisible }, props)
    ), { "aria-labelledby": ariaLabelledBy } = _a2, menuListProps = __objRest(_a2, ["aria-labelledby"]);
    props = menuListProps;
    const [initialFocusRef, setInitialFocusRef] = useState();
    const autoFocusOnShowState = store.useState("autoFocusOnShow");
    const initialFocus = store.useState("initialFocus");
    const baseElement = store.useState("baseElement");
    const items = store.useState("renderedItems");
    useEffect(() => {
      let cleaning = false;
      setInitialFocusRef((prevInitialFocusRef) => {
        var _a3, _b2, _c;
        if (cleaning)
          return;
        if (!autoFocusOnShowState)
          return;
        if ((_a3 = prevInitialFocusRef == null ? void 0 : prevInitialFocusRef.current) == null ? void 0 : _a3.isConnected)
          return prevInitialFocusRef;
        const ref2 = createRef();
        switch (initialFocus) {
          case "first":
            ref2.current = ((_b2 = items.find((item) => !item.disabled && item.element)) == null ? void 0 : _b2.element) || null;
            break;
          case "last":
            ref2.current = ((_c = [...items].reverse().find((item) => !item.disabled && item.element)) == null ? void 0 : _c.element) || null;
            break;
          default:
            ref2.current = baseElement;
        }
        if (!ref2.current)
          return;
        return ref2;
      });
      return () => {
        cleaning = true;
      };
    }, [store, autoFocusOnShowState, initialFocus, items, baseElement]);
    const modal = hasParentMenu ? false : modalProp;
    const mayAutoFocusOnShow = !!autoFocusOnShow;
    const canAutoFocusOnShow = !!initialFocusRef || !!props.initialFocus || !!modal;
    props = useHovercard(__spreadProps(__spreadValues({
      store,
      alwaysVisible,
      initialFocus: initialFocusRef,
      autoFocusOnShow: mayAutoFocusOnShow ? canAutoFocusOnShow && autoFocusOnShow : autoFocusOnShowState || !!modal
    }, props), {
      hideOnEscape: (event) => {
        if (isFalsyBooleanCallback(hideOnEscape, event))
          return false;
        store == null ? void 0 : store.hideAll();
        return true;
      },
      hideOnHoverOutside: (event) => {
        if (typeof hideOnHoverOutside === "function") {
          return hideOnHoverOutside(event);
        }
        if (hideOnHoverOutside != null)
          return hideOnHoverOutside;
        if (hasParentMenu) {
          parentMenu.setActiveId(null);
          return true;
        }
        if (!parentIsMenuBar)
          return false;
        const disclosure = store == null ? void 0 : store.getState().disclosureElement;
        if (!disclosure)
          return true;
        if (hasFocusWithin(disclosure))
          return false;
        return true;
      },
      modal,
      portal,
      backdrop: hasParentMenu ? false : props.backdrop
    }));
    props = __spreadValues({
      "aria-labelledby": ariaLabelledBy
    }, props);
    return props;
  }
);
var Menu = createDialogComponent(
  createComponent((props) => {
    const htmlProps = useMenu(props);
    return createElement("div", htmlProps);
  }),
  useMenuProviderContext
);
if (process.env.NODE_ENV !== "production") {
  Menu.displayName = "Menu";
}
export {
  Menu,
  useMenu
};
